module.exports = __webpack_public_path__ + "static/img/product-wrightinTwo.f7a89893.png";